export interface MemberShipForm {
  prefix: string
  first_name: string
  last_name: string
  address: string
  postal_code: string
  municipality_id: string
  contact_number: string
  email: string
  membership_category_id: string
  community_ids: string[]
  sponsor_full_name: string
  sponsor_member_number: string
  comments: string
  confirmation_msg: boolean
}

export const initialValues: MemberShipForm = {
  prefix: '',
  first_name: '',
  last_name: '',
  address: '',
  postal_code: '',
  municipality_id: '',
  contact_number: '+41',
  email: '',
  membership_category_id: '',
  community_ids: [],
  sponsor_full_name: '',
  sponsor_member_number: '',
  comments: '',
  confirmation_msg: false,
}
